import { Helmet } from 'react-helmet-async';
import ClinicAddTelecarePackageView from 'src/sections/clinic-dashboard/telepackages/telepackages-add-view';

export default function ClinicAddTelecarePackagePage() {
  return (
    <>
      <Helmet>
        <title>Add Telecare Package</title>
      </Helmet>

      <ClinicAddTelecarePackageView />
    </>
  );
}
